define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-construct",
	"csi/locale",
	"csi/reflection",
	"csi/def/Heading",
	"csi/def/Rule",
	"csi/widget/NodeBadge",
	"csi/xml"
], function(array,declare,lang,domConstruct,locale,reflection,Heading,Rule,NodeBadge,xml) {

	// FIX - move _mixinTooltipAction here rather than Renderer?

	return declare(null, {
		// Heading[]: headings used to render tooltip
		_tth: null,

		// {String:Rule}: mapping of template attach points to rules to manipulate template
		_ttr: null,

		addTooltipHeading: function(/*String|Class*/rc, /*Object*/params) {
			// summary: create heading with given params
			var	h = lang.mixin(new Heading(), params);

			if (rc) {
				h.resolveHeading(locale.localeResolver, null, (typeof rc === "string") ? reflection.getClass(rc) : rc);
			} else {
				h.m_right = xml.RIGHT_NONE;
			}

			this._tth = this._tth || [];
			this._tth.push(h);
			return h;
		},

		addTooltipRule: function(/*String*/key, /*Object*/params) {
			// summary: create rule with given params
			var	r = lang.mixin(new Rule(), params);
			this._ttr = this._ttr || {};
			this._ttr[key] = r;
			return r;
		},

		renderTooltip: function(/*Tooltip*/tooltip, /*Context*/ctx, /*Node[]?*/nodes, /*String?*/template) {
			// summary: generate tooltip for node(s)
			var	params = {
				ctx: ctx,
				headings: this._tth,
				rules: this._ttr
			};

			if (template) {
				params.templateString = template;
			}

			var	div = domConstruct.create("div");

			if (nodes) {
				ctx.forEach(nodes, function(ctx, i) {
					if (i) domConstruct.create("div", {"class":"csi-tooltip-separator"}, div);
					new NodeBadge(params).placeAt(div);
				});
			} else {
				new NodeBadge(params).placeAt(div);
			}

			tooltip.setContent(div);
		}
	});
});